// @flow

import * as React from "react";
import { Link } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import "./ProjectLink.css";
import { withProjectProgress } from "../../data/projects";

function progressInPercent(results: number, goal: number) {
  return results / goal * 100;
}

type StretchGoalProps = {
  numResults: number,
  initialGoal: number
};

const StretchGoal = ({ initialGoal, numResults }: StretchGoalProps) => {
  const extraResults = numResults - initialGoal;
  const stretchGoal = initialGoal + Math.ceil(extraResults / 5000) * 5000;
  return (
    <div className="ProjectLink-Progress-Stretch">
      <ProgressBar
        active
        now={progressInPercent(extraResults, stretchGoal - initialGoal)}
      />
      <div className="ProjectLink-Progress-Text">
        We achieved our goal of {initialGoal} results, and have{" "}
        {numResults - initialGoal} towards a stretch goal of {stretchGoal}.
      </div>
    </div>
  );
};

type ProjectLinkProps = {
  key: string,
  projectId: string,
  to: string,
  children?: React.Node,
  example: string,
  projectProgressData: Object,
  goal: number,
  icon: string
};

const ProjectLink = (props: ProjectLinkProps) => {
  const numResults = props.projectProgressData._allResultsMeta
    ? props.projectProgressData._allResultsMeta.count
    : 0;
  const progress = progressInPercent(numResults, props.goal);
  const isComplete = progress >= 100;
  return (
    <div className="ProjectLink">
      <Link to={props.to}>
        <div className="ProjectLink-Box">
          <img src={props.icon} alt="" />
          <div className="ProjectLink-Title">{props.children}</div>
          <div className="ProjectLink-Example">{props.example}</div>
          <div className="ProjectLink-Clear" />
        </div>
      </Link>
      <div className="ProjectLink-Progress">
        <ProgressBar active={!isComplete} now={progress} />
        {!isComplete ? (
          <div className="ProjectLink-Progress-Text">
            We have {numResults} results out of our goal of {props.goal}.
          </div>
        ) : (
          <StretchGoal numResults={numResults} initialGoal={props.goal} />
        )}
      </div>
    </div>
  );
};

export default withProjectProgress(ProjectLink);



// WEBPACK FOOTER //
// ./src/components/ProjectLink/ProjectLink.js